/*
 * Marionette ItemView: VersionInformationView
 * -------------------------
 * Displays a version information
 */
import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/version_information_view.hbs';

    var VersionInformationView = Marionette.View.extend({
        template: Handlebars.compile(template),
        initialize: function(options){
            _.each(Object.keys(options), function(opt){
                Marionette.getOption(opt, options[opt]);
            });
        },
        templateContext: function(){
            var data = {
                // __variables__ gotten from webpack.base.conf in a webpack.DefinePlugin() 
                /* eslint-disable */
                git: {
                    version_short_sha: __versionShortSha__
                },
                /* eslint-enable */
                ide_version: this.options.ide_version,
                api_version: this.options.api_version,
                beta_feedback: this.options.beta_feedback
            };
            return data;
        },
        options: {
            ide_version: '4.5.3',
            api_version: '???',
            beta_feedback: false
        }
    });
    export default VersionInformationView;

